import { useState, useEffect } from "react";
import { Select, Form } from "antd";
import { SizeType } from "antd/es/config-provider/SizeContext";

interface SelectProps {
  size: SizeType;
  parentValues: string[]; // Modificado para aceitar múltiplos estados
  isRequired?: boolean;
  handler: (value: string[]) => void; // O handler continua aceitando múltiplos valores
  disabled?: boolean;
}

const SelectField = (props: SelectProps) => {
  const [options, setOptions] = useState<{ value: string; label: string }[]>([]);

  useEffect(() => {
    const fetchMunicipios = async () => {
      try {
        // Array para armazenar todos os municípios dos estados selecionados
        let municipios: { cod: string; nome: string }[] = [];

        // Para cada estado selecionado, busca os municípios
        for (const estado of props.parentValues) {
          const response = await fetch(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${estado}/municipios`);
          const data = await response.json();
          municipios = [
            ...municipios,
            ...data.map((municipio: any) => ({
              cod: municipio.id.toString(), // Mantém o ID do município como string
              nome: `${municipio.nome}-${estado}`,
            })),
          ];
        }

        // Remove duplicatas (opcional, dependendo da estrutura dos dados)
        const uniqueMunicipios = Array.from(
          new Map(municipios.map((item) => [item.cod, item])).values()
        );

        // Ordena alfabeticamente e atualiza o estado
        setOptions(
          uniqueMunicipios
            .sort((a, b) => a.nome.localeCompare(b.nome))
            .map((municipio) => ({
              value: municipio.cod, // Mantém o código do município como string
              label: municipio.nome,
            }))
        );
      } catch (error) {
        console.error("Erro ao buscar municípios:", error);
      }
    };

    // Chama a função apenas se houver estados selecionados
    if (props.parentValues.length > 0) {
      fetchMunicipios();
    } else {
      setOptions([]); // Limpa as opções se nenhum estado estiver selecionado
    }
  }, [props.parentValues]);

  const handleChange = (value: string[]) => {
    props.handler(value); // Chama o handler com os IDs dos municípios selecionados
  };

  return (
    <Form.Item
      name="municipio"
      label="Município"
      colon={false}
      rules={[{ required: props.isRequired, message: "Campo obrigatório" }]}
    >
      <Select
        showSearch
        mode="multiple" // Permite seleção múltipla de municípios
        optionFilterProp="children"
        size={props.size}
        options={options}
        maxTagCount="responsive"
        placeholder="Município"
  disabled={props.disabled}
        filterOption={(input, option) =>
          (option?.label ?? "").toUpperCase().includes(input.toUpperCase())
        }
        onChange={handleChange} // Adiciona o onChange para lidar com a seleção
        notFoundContent="Selecione um ou mais estados"
      />
    </Form.Item>
  );
};

export default SelectField;
